/**
 * @overview 知识库编辑
 * @author 
 * @date 
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer, WizAvatarUpload, modelUtils, ossFileUtils } = framework_tool;
let { WizCard, WizInput, WizForm, Wizmessage, WizTooltip, WizIcon, WizRow, WizCol, WizButton } = component_tool;
let { Session } = utils_tool;
import { Spin } from 'antd'
import '@/styles/containers/proKnowledge/knowledgeBaseList/style.less'
import { formatAuth } from '@/utils/commonUtils'

import KnowledgeBaseForm from './knowledgeBaseForm'

class KnowledgeBaseDetail extends WizContainer {

  componentName = 'knowledgeBaseDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    let knowledgeTypeId = null;
    let version = undefined;
    let tempId = undefined;
    let versionAdd = undefined;
    let groupId = undefined;
    if (history.location && history.location.pathname === '/proKnowledge/knowledgeBaseList/knowledgeBaseDetailUpd') {
      if (history.location.record) {
        knowledgeTypeId = history.location.record.proKnowledgeTypeId
        Session.set('knowledgeTypeId', knowledgeTypeId)
        initialValue = history.location.record;
      } else {
        initialValue = Session.get('proKnowledgeInfo') || {};
        knowledgeTypeId = Session.get('knowledgeTypeId') || undefined;
      }
      version = initialValue.version
    } else if (history.location && history.location.pathname === '/proKnowledge/knowledgeBaseList/knowledgeBaseDetailAdd') {
      if (history.location.record) {
        knowledgeTypeId = history.location.record.knowledgeTypeId
        version = history.location.record.version
        tempId = history.location.record.id 
        versionAdd = history.location.record.versionAdd
        groupId =  history.location.record.groupId
        Session.set('knowledgeTypeId', knowledgeTypeId)
        Session.set("proKnowledgeAddInfo",history.location.record)
      } else {
        let proKnowledgeAddInfo = Session.get('proKnowledgeAddInfo') || {};
        knowledgeTypeId = Session.get('knowledgeTypeId') || undefined;
        version = proKnowledgeAddInfo.version;
        tempId = proKnowledgeAddInfo.id;
        versionAdd = proKnowledgeAddInfo.versionAdd;
        groupId = proKnowledgeAddInfo.groupId;
      }
    }
    this.state = {
      name: null,
      proKnowledgeTypeInfo: {},
      versionListInfo: [],
      changeListInfo: [],
      proKnowledgeTypeList: [],
      formKey: 'proKnowledgeForm',
      businessListInfo:[],
    }
    this.initialValue = initialValue;
    this.knowledgeTypeId = knowledgeTypeId;
    this.version = version;
    this.tempId = tempId;
    this.versionAdd = versionAdd;
    this.groupId = groupId;
  }

  _componentDidMount() {
    const { history } = this.props;
    //获取所有的知识类型
    this.getProKnowledgeTypes()
    //获取单个知识类型详情
    this.getProKnowledgeType(this.knowledgeTypeId)
    //获取版本信息
    this.getVersionList();
    //获取变更记录
    this.getChangeList();
    //获取单个知识详情
    this.getProKnowledgeById();
    //获取关联业务
    this.getBusinessList();
  }

  getProKnowledgeTypes() {
    this.doAction(
      {
        path: 'proKnowledgeType/export',
        payload: {
          key: 'proKnowledgeType@export',
          apiParams: {
            state:1
          }
        },
        requireLoading: true,
      }
    )
  }

  getProKnowledgeType(id) {
    this.doAction(
      {
        path: 'proKnowledgeType/getOneById',
        payload: {
          key: 'proKnowledgeType@getOneById',
          apiParams: {
            id: id
          }
        },
        requireLoading: true,
      }
    )
  }

  getVersionList(apiParams = {}) {
    let id;
    if (this.initialValue && this.initialValue.id) {
      id = this.initialValue.id
    }else if(this.tempId && this.tempId!='undefined'){
      id = this.tempId
    }
    if(id){
      this.doAction({
        path: 'proKnowledge/getVersionList',
        payload: {
          key: 'proKnowledge@getVersionList',
          apiParams: {
            id: id,
            ...apiParams
          }
        }
      })
    }
  }

  getChangeList(apiParams = {}) {
    let id;
    if (this.initialValue && this.initialValue.id) {
      id = this.initialValue.id
    }else if(this.tempId && this.tempId!='undefined'){
      id = this.tempId
    }
    if(id && !this.versionAdd){
      this.doAction({
        path: 'proKnowledge/getChangeList',
        payload: {
          key: 'proKnowledge@getChangeList',
          apiParams: {
            id: id,
            ...apiParams
          }
        }
      })
    }
  }

  getProKnowledgeById() {
    if (this.initialValue && this.initialValue.id) {
      this.doAction({
        path: 'proKnowledge/getProKnowledgeById',
        payload: {
          key: 'proKnowledge@getProKnowledgeById',
          apiParams: {
            id: this.initialValue.id,
          }
        }
      })
    }
  }

  getBusinessList(apiParams = {}) {
    let id;
    if (this.initialValue && this.initialValue.id) {
      id = this.initialValue.id
    }else if(this.tempId && this.tempId!='undefined'){
      id = this.tempId
    }
    if(id && !this.versionAdd){
      this.doAction({
        path: 'proKnowledge/getBusinessList',
        payload: {
          key: 'proKnowledge@getBusinessList',
          apiParams: {
            id: id,
            ...apiParams
          }
        }
      })
    }
  }

  propsAndStateOnChange = {
    proKnowledgeTypeInfo: this._proKnowledgeTypeInfoOver.bind(this),
    proKnowledgeAdd: this._proKnowledgeAddOver.bind(this),
    versionList: this._versionListOver.bind(this),
    changeList: this._changeListOver.bind(this),
    proKnowledgeInfo: this._proKnowledgeInfoOver.bind(this),
    proKnowledgeTypeList: this._proKnowledgeTypeListOver.bind(this),
    businessList: this._businessListOver.bind(this),
  }

  _proKnowledgeTypeInfoOver(nextProps, nextState) {
    if (nextProps.proKnowledgeTypeInfo.code == 1) {
      let proKnowledgeTypeInfo = nextProps.proKnowledgeTypeInfo.data
      nextState['proKnowledgeTypeInfo'] = proKnowledgeTypeInfo
     // nextState['businessListInfo'] = []
      this.initialValue = {id:this.initialValue.id}
      this.knowledgeTypeId = proKnowledgeTypeInfo.id
      nextState.formKey = 'proKnowledgeForm' + new Date().getTime()
    } else {
      wizNotice.error('操作失败：' + nextProps.proKnowledgeTypeInfo.msg);
    }
    return true;
  }

  _proKnowledgeAddOver(nextProps, nextState, key) {
    let o = nextProps.proKnowledgeAdd
    if (o['success']) {
      wizNotice.success(o['msg'])
      this.jumpPage('replace', '/proKnowledge/knowledgeBaseList');
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _versionListOver(nextProps, nextState) {
    if (nextProps.versionList.code == 1) {
      let versionListInfo = nextProps.versionList.data
      nextState['versionListInfo'] = versionListInfo
    } else {
      wizNotice.error('操作失败：' + nextProps.versionList.msg);
    }
    return true;
  }

  _changeListOver(nextProps, nextState) {
    if (nextProps.changeList.code == 1) {
      let changeListInfo = nextProps.changeList.data
      nextState['changeListInfo'] = changeListInfo
    } else {
      wizNotice.error('操作失败：' + nextProps.versionList.msg);
    }
    return true;
  }

  _proKnowledgeInfoOver(nextProps, nextState) {
    if (nextProps.proKnowledgeInfo.code == 1) {
      let proKnowledgeInfo = nextProps.proKnowledgeInfo.data
      this.initialValue = proKnowledgeInfo;
      Session.set('proKnowledgeInfo', proKnowledgeInfo)
      nextState.formKey = 'proKnowledgeForm' + new Date().getTime()
    } else {
      wizNotice.error('操作失败：' + nextProps.proKnowledgeInfo.msg);
    }
    return true;
  }

  _proKnowledgeTypeListOver(nextProps, nextState) {
    if (nextProps.proKnowledgeTypeList.code == 1) {
      let proKnowledgeTypeList = nextProps.proKnowledgeTypeList.data
      nextState['proKnowledgeTypeList'] = proKnowledgeTypeList
      nextState.formKey = 'proKnowledgeForm' + new Date().getTime()
    } else {
      wizNotice.error('操作失败：' + nextProps.proKnowledgeTypeList.msg);
    }
    return true;
  }

  _businessListOver(nextProps, nextState) {
    if (nextProps.businessList.code == 1) {
      let businessListInfo = nextProps.businessList.data
      nextState['businessListInfo'] = businessListInfo
    } else {
      wizNotice.error('操作失败：' + nextProps.businessList.msg);
    }
    return true;
  }

  fitterFieldsValue(data) {
    let fitterValues = {};
    let warnMsgInfo = undefined;
    if (new Date(data['startTime']).getTime() > new Date(data['endTime']).getTime()) {
      wizNotice.warn("失效时间不可早于生效时间,请确认后重试");
      return null;
    }
    Object.keys(data).forEach(key => {
      const value = data[key];
      if (key === 'startTime' && value != null && value != undefined) {
        fitterValues['startTime'] = value.format("YYYY-MM-DD HH:mm:ss");
      } else if (key === 'endTime' && value != null && value != undefined) {
        fitterValues['endTime'] = value.format("YYYY-MM-DD HH:mm:ss");
      } else if (key === 'watermark' || key === 'download') {
        if (value === null || value === undefined || value.length === 0) {
          fitterValues[key] = 0;
        } else {
          fitterValues[key] = value[0];
        }
      } else if (key === 'img' && value != null && value != undefined) {
        if (value.length) {
          fitterValues.img = value[0].fileId
        } else {
          fitterValues.img = value
        }
      } else if (key === 'belongOrg' && value != null && value != undefined) {
        fitterValues.belongOrg = value
      } else if (key === 'fileIdList' && value != null && value != undefined ) {
        console.log("value==22",value)
        let fileIdList = undefined
        if(value.contentText && value.contentText.length){
          fileIdList = [];
          value.contentText.forEach(e=>{
            if(e.fileId){
              fileIdList.push(e.fileId)
            }else if(e.uid){
              fileIdList.push(e.uid)
            }
          })
        }else if(value.length && value[0].fileId){
          fileIdList = [];
          value.forEach(e=>{
            fileIdList.push(e.fileId)
          })
        }
        // if(!fileIdList){
        //   warnMsgInfo = "知识不可为空,请确认后重试"
        // }
        console.log("fileIdList==22",fileIdList)
        fitterValues.fileIdList = fileIdList
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    let contentTypeStr = this.state.proKnowledgeTypeInfo.contentTypeStr
    if(!fitterValues.fileIdList && (!fitterValues.textContent || fitterValues.textContent=='<p></p>') && (!this.state.businessListInfo.length)){
      warnMsgInfo = "知识:"+contentTypeStr+"不可全为空,请确认后重试"
    }
    if(warnMsgInfo){
      wizNotice.warn(warnMsgInfo);
      return null;
    }

    fitterValues.authCmd = formatAuth(fitterValues.authCmd)
    fitterValues.version = this.version
    fitterValues ={businessList:this.state.businessListInfo,...fitterValues} 
    return fitterValues;
  }

  /**
   * 保存/更新
   * @param values
   * @private
   */
  _save(values, data) {
    const { history } = this.props;
    let newValues = this.fitterFieldsValue(values);
    if (!newValues) {
      return;
    }
    let apiPath = "proKnowledge/add";
    let apiParams = {
      ...newValues,
      ...data,
      groupId:this.groupId,
      //06-29 update_by pengwen 此处新增排序 
      //sort:this.sort
    }
    if (this.initialValue.id) {
      apiPath = "proKnowledge/update";
      apiParams = {
        ...newValues,
        ...data,
        id: this.initialValue.id
      }
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: "proKnowledge@add",
        apiParams: apiParams
      }
    });
  }

  /**行删除 */
  deleteRow(record) {
    const { businessListInfo} = this.state;
    let neobusinessListInfo = Object.assign([])
    for (let i = 0; i < businessListInfo.length; i++) {
      if (businessListInfo[i].sort != record.sort) {
        let entity = businessListInfo[i]
        entity.sort = neobusinessListInfo.length + 1
        neobusinessListInfo.push(entity)
      }
    }
    this.setState({
      businessListInfo: neobusinessListInfo,
      time: new Date().getTime(),
    })
  }

  /**上移下移 行数据 */
  moveUpAndDown(record) {
    const { businessListInfo } = this.state;
    if (businessListInfo.length > 1) {
      let oldsort = record.sort;
      let neobusinessListInfo = Object.assign([])
      for (let i = 0; i < businessListInfo.length; i++) {
        let entity = businessListInfo[i]
        if(record.type=='up'){
          if (oldsort == (i + 1)) {
            entity.sort = i;
          } else if (oldsort == (i + 2)) {
            entity.sort = i + 2;
          }
        }else{
          if (oldsort == (i + 1)) {
            entity.sort = i+2;
          } else if (oldsort == i) {
            entity.sort = i;
          }
        }
        neobusinessListInfo.push(entity)
      }
      //重新排序
      neobusinessListInfo.sort(function (a, b) {
        if (a['sort'] < b['sort']) {
          return -1
        }
        if (a['sort'] > b['sort']) {
          return 1
        }
        return 0;
      });
      this.setState({
        businessListInfo: neobusinessListInfo,
        time: new Date().getTime()
      })
    }
  }

  onLook(record){
    this.jumpPage('push', '/program/programList/programDetailShow',{id:record.entityId})
  }

  addRow(record){
    this.setState({
      businessListInfo: record,
      time: new Date().getTime()
    })
  }

  _clearBusinessListInfo(){
    this.setState({
      businessListInfo:[]
    })
  }

  _render() {
    const { history } = this.props;
    let initialValue = this.initialValue
    return (
      <Spin tip={'加载中'} spinning={this.props.proKnowledgeTypeLoading || this.props.proKnowledgeLoading}>
        <KnowledgeBaseForm
          key={this.state.formKey}
          proKnowledgeTypeInfo={this.state.proKnowledgeTypeInfo}
          onSubmit={this._save.bind(this)}
          proKnowledgeTypes={this.state.proKnowledgeTypeList}
          knowledgeTypeId={this.knowledgeTypeId}
          getProKnowledgeType={(id) => { this.getProKnowledgeType(id) }}
          versionListInfo={this.state.versionListInfo}
          proKnowledgeLoading={this.props.proKnowledgeLoading}
          getVersionList={(apiParams = {}) => { this.getVersionList(apiParams) }}
          getChangeList={(apiParams = {}) => { this.getChangeList(apiParams) }}
          changeListInfo={this.state.changeListInfo}
          initialValue={initialValue}
          version={this.version}

          businessListInfo={this.state.businessListInfo}
          getBusinessList={(apiParams = {}) => { this.getBusinessList(apiParams) }}
          deleteRow = {(e)=>this.deleteRow(e)}
          moveUpAndDown = {(e)=>this.moveUpAndDown(e)}
          addRow = {(e)=>this.addRow(e)}
          onLook = {(e)=>this.onLook(e)}
          clearBusinessListInfo = {()=>this._clearBusinessListInfo()}
        />
      </Spin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { proKnowledgeType, proKnowledge } = state;
  const proKnowledgeTypeInfo = modelUtils.getModelEntity(proKnowledgeType, "proKnowledgeType@getOneById");
  const proKnowledgeAdd = modelUtils.getModelEntity(proKnowledge, "proKnowledge@add");
  const versionList = modelUtils.getModelEntity(proKnowledge, "proKnowledge@getVersionList");
  const changeList = modelUtils.getModelEntity(proKnowledge, "proKnowledge@getChangeList");
  const proKnowledgeInfo = modelUtils.getModelEntity(proKnowledge, "proKnowledge@getProKnowledgeById");
  const proKnowledgeTypeList = modelUtils.getModelEntity(proKnowledgeType, "proKnowledgeType@export");

  const businessList = modelUtils.getModelEntity(proKnowledge, "proKnowledge@getBusinessList");
  
  const load = modelUtils.getLoadingState(state, ['proKnowledgeType', 'proKnowledge']);
  return {
    proKnowledgeTypeInfo,
    proKnowledgeAdd,
    versionList,
    changeList,
    proKnowledgeInfo,
    proKnowledgeTypeList,
    businessList,
    ...load
  }
};

export default connect(mapStateToProps)(KnowledgeBaseDetail);
